// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7175d85b","453":"401fe3ce","455":"4f1def4a","977":"01829b39"}[chunkId] + ".chunk.js";
};